import { useAppSelector } from "integrations/redux/hooks"
import { FunctionComponent } from "react"
import { selectActiveToolSpec } from "plugins/plugin-registry"

/**
 * Responsible for rendering any tools when they become active
 * Also responsible for rendering any corresponding menus/modals for the tools
 */
export const ToolboxProvider = () => {
    const activeTool = useAppSelector(selectActiveToolSpec)

    let ToolComponent: FunctionComponent | null = null
    if (!activeTool) {
        ToolComponent = null
    } else if (activeTool.portalComponent) {
        ToolComponent = activeTool.portalComponent
    }
    return <>{ToolComponent && <ToolComponent />}</>
}
